import type { ReactNode } from 'react';
import { Error } from 'receivable-invoices-js/react/components/mandates';
import { Loading } from 'receivable-invoices-js/react/components/shared/loading';
import { MandateInvitationForm } from 'receivable-invoices-js/react/components/mandates-invitation-form';
import { useRouteQuery } from './use-route-query';
import styles from './layout.module.css';

export function MandatesInvitationRoute(): ReactNode {
  const { data, isError, isLoading, refetch } = useRouteQuery();

  if (isLoading) {
    return <Loading spinnerSize="large" />;
  }

  if (isError || !data) {
    return (
      <div className={styles.fullScreenPage}>
        <Error errorType="generic_error" onRetry={refetch} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.pageContainer}>
        <MandateInvitationForm
          onUpdate={() => {
            // TODO: Implement form handling
          }}
        />
      </div>
    </div>
  );
}
